module.exports = __webpack_public_path__ + "static/projects-goose-view-e683265e5c2cc90e47a21704f1ae8412.jpg";